import apiClient from './client';

export interface LeadContact {
  id: number;
  lead_id: number;
  contact_id: number;
  role?: string;
  is_primary: boolean;
  created_at: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  title?: string;
  account_id?: number;
}

export interface LeadContactsResponse {
  success: boolean;
  data: LeadContact[];
}

export const leadContactsApi = {
  // Get all contacts for a lead
  getByLeadId: async (leadId: number): Promise<LeadContact[]> => {
    const response = await apiClient.get<LeadContactsResponse>(`/lead-contacts/lead/${leadId}`);
    return response.data.data;
  },

  // Get all leads for a contact
  getByContactId: async (contactId: number): Promise<LeadContact[]> => {
    const response = await apiClient.get<LeadContactsResponse>(`/lead-contacts/contact/${contactId}`);
    return response.data.data;
  },

  // Get primary contact for a lead
  getPrimaryContact: async (leadId: number): Promise<LeadContact | null> => {
    try {
      const response = await apiClient.get<{ success: boolean; data: LeadContact }>(`/lead-contacts/lead/${leadId}/primary`);
      return response.data.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  // Add a contact to a lead
  addContact: async (leadId: number, contactId: number, role?: string, isPrimary: boolean = false): Promise<LeadContact> => {
    const response = await apiClient.post<{ success: boolean; data: LeadContact }>('/lead-contacts', {
      lead_id: leadId,
      contact_id: contactId,
      role,
      is_primary: isPrimary,
    });
    return response.data.data;
  },

  // Update contact role or primary status
  update: async (leadId: number, contactId: number, data: { role?: string; is_primary?: boolean }): Promise<LeadContact> => {
    const response = await apiClient.patch<{ success: boolean; data: LeadContact }>(`/lead-contacts/${leadId}/${contactId}`, data);
    return response.data.data;
  },

  // Remove a contact from a lead
  removeContact: async (leadId: number, contactId: number): Promise<void> => {
    await apiClient.delete(`/lead-contacts/${leadId}/${contactId}`);
  },
};
